module.exports = __webpack_public_path__ + "static/lims-486e24058791eabc07f31289455dcf67.png";